import axios from "axios";

export default class Request {
  static async callInternal(opts) {
    const { method, route, data, params, customHeaders } = opts;

    let hostname = window.location.host;
    const origin = window.location.origin;
    const headers = localStorage.getItem("token")
      ? {
          ...customHeaders,
          "x-access-token": localStorage.getItem("token"),
        }
      : {
          ...customHeaders,
        };

    if (hostname === "localhost:8080" || hostname === "localhost:3000") {
      hostname = "localhost:3000";
    }

    const http = origin.includes("https") ? "https" : "http";
    const url = `${http}://${hostname}${route}`;

    return axios({
      url,
      method,
      headers,
      data,
      params,
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error.response;
      });
  }

  static async callExternal(opts) {
    const { method, url, data, params, headers } = opts;
    return axios({
      url,
      method,
      headers,
      data,
      params,
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error.response;
      });
  }
}
